import { render, staticRenderFns } from "./optimiserAllocLayoutList.vue?vue&type=template&id=5add48e2&"
import script from "./optimiserAllocLayoutList.vue?vue&type=script&lang=js&"
export * from "./optimiserAllocLayoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports